import React, { useEffect, useState } from "react";
import SearchBar from "../common/SearchBar";
import VectorIcon from "../../assets/icons/vectorIcon.svg";
import MenuIcon from "../../assets/icons/menuIcon.svg";
import LocIcon from "../../assets/icons/locIcon.svg";
import TimeIcon from "../../assets/icons/timeicon.svg";
import BagIcon from "../../assets/icons/bagIcon.svg";
import Logo from "../../assets/logo.svg";

import { useLocation, useNavigate } from "react-router-dom";

 const mockjobs = [
   {
     id: 1,
     position: "Front End Developer",
     category: "Design",
     company: "Morph & Mind",
     location: "Miami, FL",
     level: "Intermediate",
     type: "Full-time",
     time: "Remote",
     description:
       "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
     date: "June 02, 2024",
     resumNum: 101,
     views: 589,
   },
   {
     id: 2,
     position: "Front End Developer",
     category: "Design",
     company: "Morph & Mind",
     location: "Miami, FL",
      tags: ["Remote", "Full-time", "Intermediate"],
     level: "Intermediate",
     type: "Full-time",
     time: "Remote",
     description:
       "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
     date: "June 02, 2024",
     resumNum: 102,
     views: 589,
   },
   {
     id: 3,
     position: "UX UI Designer",
     category: "Design",
     company: "Morph & Mind",
     location: "Miami, FL",
      tags: ["Remote", "Full-time", "Intermediate"],
     level: "Intermediate",
     type: "Full-time",
     time: "Remote",
     description:
       "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
     date: "June 02, 2024",
     resumNum: 120,
     views: 589,
   },
   {
     id: 4,
     position: "Front End Developer",
     category: "Design",
     company: "Morph & Mind",
     location: "Miami, FL",
      tags: ["Remote", "Full-time", "Intermediate"],
     level: "Intermediate",
     type: "Full-time",
     time: "Remote",
     description:
       "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
     date: "June 02, 2024",
     resumNum: 120,
     views: 589,
   },
   {
     id: 5,
     position: "Front End Developer",
     category: "Design",
     company: "Morph & Mind",
     location: "Miami, FL",
      tags: ["Remote", "Full-time", "Intermediate"],
     level: "Intermediate",
     type: "Full-time",
     time: "Remote",
     description:
       "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
     date: "June 02, 2024",
     resumNum: 12,
     views: 589,
   },
   {
     id: 6,
     position: "SEO Expert",
     category: "Design",
     company: "Morph & Mind",
     location: "Miami, FL",
      tags: ["Remote", "Full-time", "Intermediate"],
     level: "Intermediate",
     type: "Full-time",
     time: "Remote",
     description:
       "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
     date: "June 02, 2024",
     resumNum: 102,
     views: 589,
   },
   {
     id: 7,
     position: "Front End Developer",
     category: "Design",
     company: "Morph & Mind",
     location: "Miami, FL",
      tags: ["Remote", "Full-time", "Intermediate"],
     level: "Intermediate",
     type: "Full-time",
     time: "Remote",
     description:
       "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
     date: "June 02, 2024",
     resumNum: 120,
     views: 589,
   },
   {
     id: 8,
     position: "Front End Developer",
     category: "Design",
     company: "Morph & Mind",
     location: "Miami, FL",
      tags: ["Remote", "Full-time", "Intermediate"],
     level: "Intermediate",
     type: "Full-time",
     time: "Remote",
     description:
       "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
     date: "June 02, 2024",
     resumNum: 200,
     views: 589,
   },
   {
     id: 9,
     position: "Full Stack Developer",
     category: "Design",
     company: "Morph & Mind",
     location: "Miami, FL",
      tags: ["Remote", "Full-time", "Intermediate"],
     level: "Intermediate",
     type: "Full-time",
     time: "Remote",
     description:
       "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
     date: "June 02, 2024",
     resumNum: 120,
     views: 589,
   },
   {
     id: 10,
     position: "UX UI Designer",
     category: "Design",
     company: "Morph & Mind",
     location: "Miami, FL",
      tags: ["Remote", "Full-time", "Intermediate"],
     level: "Intermediate",
     type: "Full-time",
     time: "Remote",
     description:
       "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
     date: "June 02, 2024",
     resumNum: 120,
     views: 589,
   },
 ];

function CandidateAppliedJobs() {
  const filters = [
    "All",
    "UX UI Designer",
    "Front End Developer",
    "Full Stack Developer",
    "SEO Expert",
    "More filters",
  ];

  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    const storedJobs = JSON.parse(sessionStorage.getItem("appliedJobs")) || [];
    setJobs(mockjobs);
  }, []);

  const [filter, setFilter] = useState("All");
  const navigate = useNavigate();
   const location = useLocation();
   const test = Array.isArray(location.state)
     ? location.state
     : [location.state];

  const handleCardClick = (job) => {
    navigate(`/candidate/jobs/applied-details/${job.id}`, { state: job });
  };

  const filteredJobs =filter === "All"
      ? jobs
      : jobs.filter((job) =>
          job.position.toLowerCase().includes(filter.toLowerCase())
        );

   

  return (
    <div>
      {/* div heading */}
      <div className="flex justify-between items-center ">
        <div>
          <h1 className="text-gray-800 font-semibold text-lg ">Applied Jobs</h1>
          <p className="text-gray-400 font-normal text-sm">
            Here are all the Jobs you've applied.
          </p>
        </div>
        <div className="flex gap-3 items-center">
          <button
            className="px-4 py-3 cursor-pointer rounded-lg bg-[#19BFB7] text-white text-sm font-semibold"
            onClick={() => navigate("/candidate/jobs")}
          >
            Browse Jobs
          </button>
          <SearchBar />
        </div>
      </div>

      <div className="mt-16 flex flex-col gap-10">
        {/* div filter */}
        <div className=" flex justify-between items-center">
          <div className="flex gap-3 items-center">
            {filters.map((f, index) => (
              <button
                key={index}
                onClick={() => setFilter(f)}
                className={`border border-gray-200  px-4 py-2 cursor-pointer rounded-lg text-gray-700 text-xs font-semibold ${
                  filter === f
                    ? "bg-[#19BFB7] text-white border-none "
                    : "hover:bg-gray-100 duration-150 transition"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
          <div className="flex gap-5 items-center">
            <button className="border border-gray-200 rounded-md p-1.5 cursor-pointer hover:bg-gray-100 duration-150 transition text-gray-700 ">
              <img src={VectorIcon} alt="" />
            </button>{" "}
            <button className="border border-gray-200 rounded-md p-1.5 cursor-pointer hover:bg-gray-100 duration-150 transition text-gray-700 ">
              <img src={MenuIcon} alt="" />
            </button>
          </div>
        </div>

        {/* div card */}
        <div className="grid xl:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-5">
          {jobs ? (
            filteredJobs.map((job) => (
              <div
                key={job.id}
                onClick={() => handleCardClick(job)}
                className="border border-gray-200 rounded-lg p-4 flex flex-col gap-3   shadow-sm hover:shadow-lg duration-150 transition"
                   style={{
                     boxShadow: " rgba(0, 0, 0, 0.16) 0px 1px 1px",
                   }}
              >
                <div
                  className="pb-5 border-b border-gray-200 flex flex-col gap-3 cursor-pointer"
                   onClick={() => handleCardClick(job)}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex gap-2 items-center">
                      <img
                        src={Logo}
                        className="w-7 h-7 rounded-full"
                        alt="Company Logo"
                      />
                      <div className="flex flex-col gap-1">
                        <div className="flex gap-2 items-baseline ">
                          <h2 className="text-gray-800 text-[16px] font-semibold ">
                            {job.position}
                          </h2>
                          <span className="border border-blue-300 bg-blue-100 text-blue-500 font-semibold px-3 py-1 rounded-xl text-[10px] flex gap-1 items-center">
                            <span> &bull; </span>
                            {job.category}
                          </span>
                        </div>
                        <div className="flex ">
                          <p className="text-gray-500 font-normal pr-2 text-xs border-r border-gray-500">
                            {job.company}
                          </p>
                          <p className="text-gray-500 font-normal text-xs  pl-2">
                            {job.location}
                          </p>
                        </div>
                      </div>
                    </div>
                    <button className="cursor-pointer text-gray-700 p-2 text-xl">
                      &#x22EE;
                    </button>
                  </div>

                  <div className="flex gap-3 items-center">
                    <span className="text-gray-500 font-semibold text-xs flex gap-1 items-center">
                      <img src={LocIcon} alt="loc icon" className="w-4 h-4" />
                      {job.type}
                    </span>
                    <span className="text-gray-500 font-semibold text-xs flex gap-1 items-center">
                      <img src={TimeIcon} alt="time icon" className="w-4 h-4" />
                      {job.time}
                    </span>
                    <span className="text-gray-500 font-semibold text-xs flex gap-1 items-center">
                      <img src={BagIcon} alt="bag icon" className="w-4 h-4" />
                      {job.level}
                    </span>
                  </div>

                  <div className="">
                    <p className="text-gray-500  font-normal text-xs leading-5">
                      {job.description.split(" ").slice(0, 25).join(" ") +
                        "..."}
                    </p>
                  </div>
                </div>

                <div className="flex items-center justify-between pt-1">
                  <div className="font-semibold border border-green-300 bg-green-50 text-green-600 px-3 py-1 rounded-lg text-sm ">
                    Shortlisted
                  </div>
                  <button className="text-red-600 font-semibold px-3 py-1 cursor-pointer text-sm">
                    Withdraw Application
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-900">test</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default CandidateAppliedJobs;